import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'fleet-data-item',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col">
      <div class="flex items-center justify-between mb-1" *ngIf="label">
        <div class="text-sm text-gray-500">{{ label }}</div>
        <ng-content select="[slot='action']"></ng-content>
      </div>
      <div class="text-sm font-semibold text-gray-700">
        <ng-container *ngIf="value">{{ value }}</ng-container>
        <ng-content *ngIf="!value"></ng-content>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataItemComponent {
  @Input() label: string;
  @Input() value: string;
}
